import { render, staticRenderFns } from "./DataSummaryCard.vue?vue&type=template&id=3a53329c&scoped=true"
import script from "./DataSummaryCard.vue?vue&type=script&lang=js"
export * from "./DataSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./DataSummaryCard.vue?vue&type=style&index=0&id=3a53329c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53329c",
  null
  
)

export default component.exports